<template>
	<nav id="navbar" class="navbar navbar-expand-lg navbar-dark bg-dark px-0 px-md-5 pt-5">
		<router-link to="/" class="navbar-brand"><img class="ms-5" height="40" alt="" src="/img/icons/logo.png"></router-link>
		<button @click="toggleNav" class="navbar-toggler pe-all ms-auto me-2" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
				aria-controls="navbarSupportedContent"
				aria-expanded="false"
				aria-label="Toggle navigation">
			<span class="navbar-toggler-icon"></span>
		</button>

		<div class="collapse navbar-collapse" id="navbarSupportedContent">
			<ul class="navbar-nav ms-auto">
				<li class="nav-item me-3">
					<button @click="toggleShare" class="btn btn-outline-light btn-outline-none btn-lg"><i class="fa fa-share me-2"></i> Share</button>
				</li>
				<li class="nav-item">
					<a :href="socials.discord" target="_blank" class="btn btn-outline-light btn-lg">Join Discord</a>
				</li>
				<li class="nav-item">
					<a :href="socials.twitter" target="_blank" class="social-icon"><img alt="" src="/img/icons/social/twitter.svg" height="32" class="mt-2 ms-3 p-1"></a>
				</li>
			</ul>
		</div>
		<ShareSite @close="toggleShare" v-if="showShare"></ShareSite>
	</nav>
</template>

<script>
import ShareSite from "@/components/common/ShareSite";

export default {
	name: "Navbar",
	components: {ShareSite},
	data() {
		return {
			showShare: false,
			navContent: null,
			navContainer: null,
			socials: {
				twitter: "https://twitter.com/hourglass_ab",
				discord: "https://discord.gg/cgKGFQG4jM"
			}
		}
	},
	methods: {
		toggleShare: function () {
			this.showShare = !this.showShare
		},

		toggleNav: function () {
			this.navContent.classList.toggle("show")
			this.navContainer.classList.toggle("show")
		}
	},
	mounted() {
		this.navContent = document.getElementById("navbarSupportedContent")
		this.navContainer = document.getElementById("navbar")
	}
}
</script>

<style scoped>
.social-icon {
	border-radius: 33px;
	filter: invert();
}

nav {
	background: transparent !important;
	z-index: 3;
	pointer-events: all;
}
</style>